module.exports = __webpack_public_path__ + "img/selected2-min.cbc9f9a3.png";